export { AtnDsIntegratedVerticalTabsComponent as Component } from './integrated-vertical-tabs.component'
